module.exports = __webpack_public_path__ + "media/images/map/swipe-arrow-b2e728353fdbd5c2c1ab3990b5708b32.svg";